import {ScimConfigId, CreateScimConfig} from "platformed-client/types";
import {invalidateQueries, q} from "../state";
import {platformedClient} from ".";

export async function listConfigs() {
  return await platformedClient.internalRequest("get", "/region/{region}/api/scim_configs", {path: {}});
}

export async function createConfig(config: CreateScimConfig) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/scim_configs", {
    path: {},
    body: config,
  });
  await invalidateQueries([q.scimConfigs.filter()]);
  return res;
}

export async function updateConfigName(configId: ScimConfigId, name: string) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/scim_configs/{scim_config_id}/name",
    {path: {scim_config_id: configId}, body: name},
  );
  await invalidateQueries([q.scimConfigs.filter()]);
  return res;
}

export async function updateConfigSendInvitations(configId: ScimConfigId, sendInvitations: boolean) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/scim_configs/{scim_config_id}/send_invitations",
    {path: {scim_config_id: configId}, body: sendInvitations},
  );
  await invalidateQueries([q.scimConfigs.filter()]);
  return res;
}

export async function regenerateConfigToken(configId: ScimConfigId) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/scim_configs/{scim_config_id}/auth_token",
    {path: {scim_config_id: configId}},
  );
  await invalidateQueries([q.scimConfigs.filter()]);
  return res;
}

export async function deleteConfig(configId: ScimConfigId) {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/scim_configs/{scim_config_id}", {
    path: {scim_config_id: configId},
  });
  await invalidateQueries([q.scimConfigs.filter()]);
  return res;
}
